import React from "react"
import { Container } from "reactstrap"
import styled from "styled-components"

let SubFooter = ({ title }) => (
  <SubFooterStyling>
    <Container fluid className="pb-3">
      <span className="text-secondary small">
        Copyright © {new Date().getFullYear()}. {title}. All rights reserved.
      </span>
    </Container>
  </SubFooterStyling>
)

export default SubFooter

const SubFooterStyling = styled.div`
  background: ${({ theme }) => theme.backgroundSecondary};
`
